import api from "utils/api";

export const seedDefaultGamificationSettings = async () => {
  try {
    const response = await api.post("/gamification/settings/seed-defaults");
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getGamificationSettings = async (params = {}) => {
  try {
    const response = await api.get("/gamification/settings", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const createGamificationSetting = async (data) => {
  try {
    const response = await api.post("/gamification/settings", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const updateGamificationSetting = async (id, data) => {
  try {
    const response = await api.put(`/gamification/settings/${id}`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const deactivateGamificationSetting = async (id) => {
  try {
    const response = await api.delete(`/gamification/settings/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const evaluateGamification = async (data) => {
  try {
    const response = await api.post("/gamification/evaluate", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getGamificationScores = async (params = {}) => {
  try {
    const response = await api.get("/gamification/scores", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getBadgeEligibilities = async (params = {}) => {
  try {
    const response = await api.get("/gamification/eligibilities", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getBadgeEligibilityStats = async (params = {}) => {
  try {
    const response = await api.get("/gamification/eligibilities/stats", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const reviewBadgeEligibility = async (id, data) => {
  try {
    const response = await api.put(`/gamification/eligibilities/${id}/review`, data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const assignApprovedEligibility = async (id) => {
  try {
    const response = await api.put(`/gamification/eligibilities/${id}/assign`);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const getTutorBadges = async (params = {}) => {
  try {
    const response = await api.get("/gamification/badges", { params });
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};

export const manualAssignBadge = async (data) => {
  try {
    const response = await api.post("/gamification/badges/manual", data);
    return response.data;
  } catch (error) {
    throw error.response?.data || error;
  }
};
